import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { CodexByEffortPoint } from '@ace-tracker/shared';
import { chartAxisTickProps, chartLegendProps, chartTooltipProps, chartXAxisTickProps } from '../chartTheme';

const EFFORT_ORDER = ['low', 'medium', 'high', 'unknown'];

/**
 * Input/output token volume by Codex's reasoning-effort setting — a signal
 * unique to Codex among the three collectors (neither Copilot nor Claude
 * Code exposes a comparable per-request effort knob).
 */
export function EffortMixChart({ byEffort }: { byEffort: CodexByEffortPoint[] }) {
  const sorted = [...byEffort].sort((a, b) => EFFORT_ORDER.indexOf(a.effort) - EFFORT_ORDER.indexOf(b.effort));

  if (sorted.length === 0) {
    return <p className="flex h-full items-center justify-center text-sm text-text-muted">No usage in this range.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={sorted} accessibilityLayer>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--line-soft)" />
        <XAxis dataKey="effort" {...chartXAxisTickProps} />
        <YAxis {...chartAxisTickProps} />
        <Tooltip {...chartTooltipProps} />
        <Legend {...chartLegendProps} />
        <Bar dataKey="inputTokens" stackId="tokens" fill="#0058AB" name="Input tokens" />
        <Bar dataKey="outputTokens" stackId="tokens" fill="#06D6A0" name="Output tokens" />
      </BarChart>
    </ResponsiveContainer>
  );
}
